module.exports = __webpack_public_path__ + "static/media/photo-pts.6b0843f4.png";